var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94519 17.8357C5.94519 17.0149 6.61063 16.3494 7.4315 16.3494L28.2398 16.3494C29.0607 16.3494 29.7262 17.0149 29.7262 17.8357C29.7262 18.6566 29.0607 19.322 28.2398 19.322L7.4315 19.322C6.61063 19.322 5.94519 18.6566 5.94519 17.8357Z",
    fill: "#161B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.271 27.8046C17.6906 27.2241 17.6906 26.283 18.271 25.7026L26.1379 17.8357L18.271 9.96884C17.6906 9.3884 17.6906 8.44732 18.271 7.86688C18.8514 7.28644 19.7925 7.28644 20.373 7.86688L29.2908 16.7847C29.8713 17.3652 29.8713 18.3063 29.2908 18.8867L20.373 27.8046C19.7925 28.385 18.8514 28.385 18.271 27.8046Z",
    fill: "#161B2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon);
export default __webpack_public_path__ + "static/media/modalIcon.51441e2c136cedf61ebb7e2044268eba.svg";
export { ForwardRef as ReactComponent };